var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import DataTable from '@/components/data-table/DataTable';
import PageHeader from '@/components/page-header/PageHeader';
import ErrorHandler from '@/support/ErrorHandler';
import { ProjectIncludes, Project } from '@/models/Project';
import CreateProjectDialog from '@/views/Projects/CreateProjectDialog/CreateProjectDialog';
let Projects = class Projects extends Vue {
    constructor() {
        // File structure for Typescript files in your Vue project
        // https://tutorials.atabix.com/frontend/typscript_file_structure/
        super(...arguments);
        // #region @Props
        // #endregion
        // #region @Refs
        // #endregion
        // #region Class properties
        this.$pageTitle = 'Projects';
        this.isCreatingProject = false;
        // #endregion
        // #region @Watchers
        // #endregion
    }
    // #endregion
    // #region Lifecycle Hooks / Init
    // #endregion
    // #region Class methods
    refreshDataTable() {
        document.dispatchEvent(new CustomEvent('datatable:hook', {
            detail: (dataTable) => {
                dataTable.refresh();
            },
        }));
    }
    dialogOptions(project) {
        return {
            title: this.$t('dialogOptions.confirmation').toString(),
            text: this.$tc('dialogOptions.delete', 1, { item: this.$t('dialogOptions.item.project') }).toString(),
            type: 'warning',
            buttons: {
                confirm: {
                    text: this.$t('dialogOptions.button.delete').toString(),
                    action: () => {
                        if (!project) {
                            return;
                        }
                        project
                            .delete()
                            .then((response) => {
                            if (response) {
                                this.refreshDataTable();
                            }
                        })
                            .catch((error) => {
                            ErrorHandler.network(error);
                        });
                    },
                },
                cancel: {
                    text: this.$t('dialogOptions.button.cancel').toString(),
                },
            },
        };
    }
    // #endregion
    // #region Async methods
    // #endregion
    // #region Getters & Setters
    get tableOptions() {
        const model = new Project().include([ProjectIncludes.CHAT, ProjectIncludes.SUBJECTS, ProjectIncludes.META]);
        if (this.$route.meta && this.$route.meta.myProject) {
            model.filter({ user: this.$store.state.Auth.id });
        }
        return {
            model,
            name: {
                singular: this.$tc('projects.title', 1),
                plural: this.$tc('projects.title', 2),
            },
            headers: [
                {
                    text: `${this.$t('projects.table.name')}`,
                    value: 'name',
                    action: '/projects/{id}',
                    width: '25%',
                },
                {
                    text: `${this.$t('projects.table.description')}`,
                    value: 'description',
                },
                {
                    text: `${this.$t('projects.table.subjects')}`,
                    value: 'meta',
                    transform: (meta) => meta.subject_count || '-',
                    width: '10%',
                },
            ],
            actions: [
                {
                    type: 'view',
                    label: 'view',
                    icon: 'remove_red_eye',
                    action: '/projects/{id}',
                },
                {
                    type: 'delete',
                    label: 'delete',
                    icon: 'delete',
                    action: (vm, project) => {
                        this.$store.dispatch('openDialog', this.dialogOptions(project));
                    },
                },
            ],
            filters: [],
        };
    }
};
Projects = __decorate([
    Component({
        components: {
            DataTable,
            PageHeader,
            CreateProjectDialog,
        },
    })
], Projects);
export default Projects;
